// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorPopover-cls1_m8X","cls2":"AuthorPopover-cls2_oc2 AuthorPopover-cls1_m8X"};